<div *ngIf="Editing" class="image-editing-wrapper">
    <button app-round-button matTooltip="Bild hinzufügen" aria-label="Bild hinzufügen"><fa-icon icon="upload" (click)="logoUpload.click()"></fa-icon></button>
    <div *ngIf="!(File$ | async) && !(FileCache$ | async)" class="full-screen-image file-placeholder">
        <fa-icon icon="camera" size="5x"></fa-icon>
    </div>
    <input id="file" accept="image/*" type="file" hidden #logoUpload (change)="OnFileChange($event)" />
</div>
<ng-container *ngIf="ImageSource$ | async as imageSrc">
    <ng-container *ngIf="imageSrc">
        <div class="no-image" *ngIf="!FileIsLoaded">
            <app-loading></app-loading>
        </div>
        <img
            class="full-screen-image"
            [class.hide]="!FileIsLoaded"
            [src]="imageSrc"
            (load)="FileIsLoaded = true"
        />
    </ng-container>
</ng-container>
<div class="button-wrapper">
    <div class="theme-override {{ DMSMeta.Theme }}" *ngIf="FolderId as folderId">
        <a app-button class="wide-button" matTooltip="DMS" aria-label="DMS" [routerLink]="['/', DMSMeta.Path]" [queryParams]="{ folderId }"><fa-icon [icon]="DMSMeta.Icon"></fa-icon></a>
    </div>
    <div class="theme-override {{ ResourcePageMeta.Theme }}" *ngIf="ShowResourceButton">
        <a app-button class="wide-button" matTooltip="Ressource" aria-label="Ressource"[routerLink]="[ResourcePageMeta.Path, (Resource$ | async)?.Id]"><fa-icon [icon]="ResourcePageMeta.Icon"></fa-icon></a>
    </div>
</div>
<app-loading *ngIf="Loading"></app-loading>
<app-detail-list-template [Data]="DetailList$ | async" [Editing]="Editing" [Inline]="true"> </app-detail-list-template>
<div class="custom-field-wrapper" *ngIf="Editing">
    <div class="header">
        <h4>Zusätzliche Felder</h4>
        <button app-round-button matTooltip="Zusätzliche Daten anlegen" aria-label="Zusätzliche Daten anlegen" (click)="OpenCustomFieldPopup()"><fa-icon icon="plus"></fa-icon></button>
    </div>
    <div class="field" *ngFor="let field of CustomFields; let i = index">
        <mat-form-field *ngIf="field.type === CustomFieldTypes.text">
            <input matInput [formControl]="field.formControl" type="text" [placeholder]="field.name" />
        </mat-form-field>
        <mat-form-field *ngIf="field.type === CustomFieldTypes.number">
            <input matInput [formControl]="field.formControl" type="number" [placeholder]="field.name" />
        </mat-form-field>
        <mat-form-field  *ngIf="field.type === CustomFieldTypes.date">
            <input matInput [matDatepicker]="picker" [placeholder]="field.name" [formControl]="field.formControl" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <button app-round-button matTooltip="Bearbeiten" aria-label="Bearbeiten" (click)="OpenCustomFieldPopup(i)"><fa-icon icon="pencil-alt"></fa-icon></button>
    </div>
</div>
<ng-template #selectResourceType>
    <div class="selectResourceType">
        <mat-form-field>
            <app-select-search
                required
                [placeholder]="'Art der Ressource'"
                [formControl]="ResourceForm.controls.ResourceTypeId"
                [Options]="ResourceTypes"
                [CompareOptions]="CompareById"
            ></app-select-search>
        </mat-form-field>
        <button app-round-button matTooltip="Ressourcenart anlegen" aria-label="Ressourcenart anlegen" (click)="NewResourceTypePopUp()"><fa-icon icon="plus"></fa-icon></button>
    </div>
</ng-template>
